/*** IMPORTS FROM imports-loader ***/
var define = false;

export function stickyNav() {
  // var windowHeight = window.innerHeight;
  // alert(windowHeight);
  // var logoPosition = $('.hero__logo').offset();
  // alert(logoPosition.top);
  $(window).scroll(function () {
    if ($(this).scrollTop() > 5) {
      $("body").addClass("scrolled");
    } else {
      $("body").removeClass("scrolled");
    }
  });
}
